import { BondRecordResponse } from "../../components/forms/FormBondApp.types";
import { ServiceBase } from "../core";
import { ApiParams } from "../types";

class SchemaService extends ServiceBase {
  public static async getBondApplicantForm() {
    const data: ApiParams = {
      method: "GET",
      url: "/system/public/bond-form/json-schema/additional_individual_principal_information"
    };
    const response = await ServiceBase.callApi(data);

    return response;
  }

  public static async getBondRecords(object?: any, accessKey?: string) {
    const url = accessKey?.length
      ? `/bond-records?access_key=${accessKey}`
      : `/bond-records`;

    const data: ApiParams = {
      method: "POST",
      url,
      data: object
    };

    const response: BondRecordResponse = await ServiceBase.callApi(data);

    return response;
  }

  public static async getBondRecordData(
    productId: string | null,
    accessKey: string | null,
    paymentStatus: string | null
  ) {
    const url =
      !paymentStatus ||
      (paymentStatus && paymentStatus.toUpperCase() !== "SUCCEEDED")
        ? `/bond-records/${productId}?access_key=${accessKey}`
        : `/bond-records/${productId}?access_key=${accessKey}&force_refresh=1`;

    const data: ApiParams = {
      method: "GET",
      url: url
    };
    const response: BondRecordResponse = await ServiceBase.callApi(data);

    return response;
  }

  public static async getBondBasicSchema() {
    const data: ApiParams = {
      method: "GET",
      url: "/system/public/bond-form/json-schema/basic_principal_information"
    };
    const response = await ServiceBase.callApi(data);

    return response;
  }

  public static async getBondBusinessSchema() {
    const data: ApiParams = {
      method: "GET",
      url: "/system/public/bond-form/json-schema/additional_business_principal_information"
    };
    const response = await ServiceBase.callApi(data);

    return response;
  }

  public static async getBondRiskAssessmentSchema() {
    const data: ApiParams = {
      method: "GET",
      url: "/system/public/bond-form/json-schema/bond_risk_assessment_options"
    };
    const response = await ServiceBase.callApi(data);

    return response;
  }

  public static async getBondIndemnitorSchema() {
    const data: ApiParams = {
      method: "GET",
      url: "/system/public/bond-form/json-schema/bond_indemnitor"
    };
    const response = await ServiceBase.callApi(data);

    return response;
  }

  //https://ezsb-sbm-api-stable-nl.anthros-staging.com/api/v1/system/public/bond-form/json-schema/bond_options

  public static async getBondOptionsSchema() {
    const data: ApiParams = {
      method: "GET",
      url: "/system/public/bond-form/json-schema/bond_options"
    };
    const response = await ServiceBase.callApi(data);

    return response;
  }

  public static async getProductSchema(id: string | null) {
    const data: ApiParams = {
      method: "GET",
      url: `/products/${id}/forms/current/schema`
    };
    const response = await ServiceBase.callApi(data);

    return response;
  }

  public static async getBondAgencyQuestionsSchema() {
    try {
      const data: ApiParams = {
        method: "GET",
        url: "/system/public/bond-form/json-schema/bond_agency_questions"
      };
      const response = await ServiceBase.callApi(data);
      if (response?.data && response?.data?.schema) {
        return response;
      }
      return undefined;
    } catch (error) {
      return undefined;
    }
  }
}

export default SchemaService;
